import React from "react"

const PerguntaUsuario = ({ message }) => (
  <li className="perguntaWatson d-flex justify-content-end" style={{ marginRight: "4%" }}>
    <span className="pergunta-watson__should-break">{message}</span>
  </li>
)

export default PerguntaUsuario
